import Image from 'next/image';
import classNames from 'classnames';

import pranaClubLogoContrast from '~/assets/prana-club-logo-contrast.png';
import pranaClubLogo from '~/assets/prana-club-logo.png';

import './themed-logo.scss';

type ThemedLogoProps = Readonly<{
  alt?: string;
  className?: string;
  itemProp?: string;
  priority?: boolean;
}>;

const ThemedLogo = ({ alt = 'Prana Club logo', className, itemProp, priority = false }: ThemedLogoProps) => {
  return (
    <span className={classNames('themed-logo', className)} itemProp={itemProp}>
      <Image
        src={pranaClubLogoContrast}
        alt={alt}
        className="themed-logo__image themed-logo__image--light"
        priority={priority}
      />
      <Image
        src={pranaClubLogo}
        alt=""
        aria-hidden="true"
        className="themed-logo__image themed-logo__image--dark"
        priority={priority}
      />
    </span>
  );
};

export default ThemedLogo;
